<div id="nav-bar-top">

  <!-- DROPDOWN WITH ALL SITES -->
  <div id="box-dropdown" *ngIf="!hideSitesSelection" class="left-side">
    <app-dropdown-sites *ngIf="listeSites.length > 0" [listeSites]="listeSites" [currentSite]="selectedSite"
      (siteSelected)="definirSiteEnCours($event)" />
  </div>

  <!-- SETTINGS SECTION -->
  <div id="settings" class="no-select left-side">
    <button class="btn-form ms-2 tertiary-button" (click)="navigateToSettings()">
      <i class="fa-solid fa-gear me-2"></i>
      {{ 'USER.SETTINGS' | translate }}
    </button>
  </div>

  <!-- USER PROFILE NAME -->
  <div #user id="user" class="no-select col-5" (click)="
      toggleSelectArray[0] = !toggleSelectArray[0]; toggleSelectArray[1] = false
    ">
    <div style="justify-content: flex-end" >
      <svg width="14" height="16" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M6.9177 1.60714C5.27112 1.60714 3.9363 2.94196 3.9363 4.58854C3.9363 6.23512 5.27112 7.56994 6.9177 7.56994C8.56428 7.56994 9.89909 6.23512 9.89909 4.58854C9.89909 2.94196 8.56428 1.60714 6.9177 1.60714ZM9.81538 8.14655C10.8473 7.30516 11.5062 6.0238 11.5062 4.58854C11.5062 2.05436 9.45188 0 6.9177 0C4.38351 0 2.32916 2.05436 2.32916 4.58854C2.32916 6.02381 2.98813 7.30516 4.02002 8.14656C1.48956 9.23483 0 11.7066 0 14.1964C0 14.6402 0.359771 15 0.803571 15C1.24737 15 1.60714 14.6402 1.60714 14.1964C1.60714 11.7028 3.60198 9.17708 6.9177 9.17708C10.2334 9.17708 12.2284 11.7028 12.2284 14.1964C12.2284 14.6402 12.5881 15 13.0319 15C13.4757 15 13.8355 14.6402 13.8355 14.1964C13.8355 11.7066 12.3459 9.23482 9.81538 8.14655Z"
          fill="#121212" />
      </svg>
    </div>

    <div style="justify-content: flex-end" [ngClass]="{'button-color': toggleSelectArray[0]}" >
      {{ keycloakService.fullName}}
    </div>

    <!-- USER PROFILE DROPDOWN -->
    <div class="dropdown-container" [style.width]="userDivWidth"
      [ngClass]="{ close: !toggleSelectArray[0], open: toggleSelectArray[0] }" (mouseleave)="hideDropdown(0)">
      <ul class="dropdown-options" #dropdown [style.width]="userDivWidth"
        [ngClass]="{ close: !toggleSelectArray[0], open: toggleSelectArray[0] }">
        <li class="dropdown-option custom-with-profile pt-2 pb-2">
          <svg width="14" height="16" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg" class="ms-2">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M6.9177 1.60714C5.27112 1.60714 3.9363 2.94196 3.9363 4.58854C3.9363 6.23512 5.27112 7.56994 6.9177 7.56994C8.56428 7.56994 9.89909 6.23512 9.89909 4.58854C9.89909 2.94196 8.56428 1.60714 6.9177 1.60714ZM9.81538 8.14655C10.8473 7.30516 11.5062 6.0238 11.5062 4.58854C11.5062 2.05436 9.45188 0 6.9177 0C4.38351 0 2.32916 2.05436 2.32916 4.58854C2.32916 6.02381 2.98813 7.30516 4.02002 8.14656C1.48956 9.23483 0 11.7066 0 14.1964C0 14.6402 0.359771 15 0.803571 15C1.24737 15 1.60714 14.6402 1.60714 14.1964C1.60714 11.7028 3.60198 9.17708 6.9177 9.17708C10.2334 9.17708 12.2284 11.7028 12.2284 14.1964C12.2284 14.6402 12.5881 15 13.0319 15C13.4757 15 13.8355 14.6402 13.8355 14.1964C13.8355 11.7066 12.3459 9.23482 9.81538 8.14655Z"
              fill="#121212" />
          </svg>

          <span>{{ 'BUTTONS.PROFILE' | translate }}</span>
        </li>
        <li class="dropdown-option custom-with-profile pt-2 pb-2" (click)="keycloakService.logout()">
          <img class="ms-2" src="icon/logout.svg" />
          <span>{{ 'BUTTONS.LOGOUT' | translate }} </span>
        </li>
      </ul>
    </div>

    <div class="fa-solid fa-caret-down" (click)="toggleSelectArray[0] = !toggleSelectArray[0]" [ngClass]="{
        'rotate-down': !toggleSelectArray[0],
        'rotate-up': toggleSelectArray[0],
        'button-color': toggleSelectArray[0]
      }"></div>
  </div>



  <!-- LANGUAGE NAME -->
  <div #language id="language" class="no-select" (click)="
      toggleSelectArray[1] = !toggleSelectArray[1]; toggleSelectArray[0] = false
    ">
    <div [ngClass]="{'button-color': toggleSelectArray[1]
      }" >{{ currentLang.toUpperCase() }}</div>

    <!-- LANGUAGE DROPDOWN -->
    <div class="dropdown-container pr-3" [style.width]="userDivWidth"
      [ngClass]="{ close: !toggleSelectArray[1], open: toggleSelectArray[1] }">
      <ul class="dropdown-options custom-with-language" #dropdown
        [ngClass]="{ close: !toggleSelectArray[1], open: toggleSelectArray[1] }" (mouseleave)="hideDropdown(1)">
        <li class="dropdown-option pt-2 pb-2" (click)="changeLanguage('fr')" [ngClass]="{'highlighted-option': currentLang === 'fr'}">
          <img class="ms-2" src="./icon/langue-fr.svg" />
          <span>Français</span>
        </li>
        <li class="dropdown-option pt-2 pb-2" (click)="changeLanguage('en')" [ngClass]="{'highlighted-option': currentLang === 'en'}">
          <img class="ms-2" src="./icon/langue-eng.svg" />
          <span>English</span>
        </li>
        <li class="dropdown-option pt-2 pb-2" (click)="changeLanguage('es')" [ngClass]="{'highlighted-option': currentLang === 'es'}">
          <img class="ms-2" src="./icon/langue-esp.svg" />
          <span>Español</span>
        </li>
      </ul>
    </div>

    <div class="fa-solid fa-caret-down" [ngClass]="{
        'rotate-down': !toggleSelectArray[1],
        'rotate-up': toggleSelectArray[1],
        'button-color': toggleSelectArray[1]
      }"></div>
  </div>

</div>